import {IOverride} from "../../../../index";
import {AbstractSystemPermission} from "../AbstractSystemPermission";

export interface IParams {
    sp: AbstractSystemPermission
}

export class PermissionCellAbstract {

    protected readonly override: KnockoutObservable<IOverride | null>;
    protected readonly sp: AbstractSystemPermission;

    constructor(protected params: IParams) {
        this.sp = params.sp;
        this.override = this.sp.override;
    }

}
